import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from "@angular/core";
import { Router, ActivatedRoute} from '@angular/router';
import {SearchService} from '../../../../services/search.service'
declare var $: any;
import * as moment from "moment";
import { MDCRadio } from "@material/radio";
import { MDCFormField } from "@material/form-field";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { NewDatepickerComponent } from "src/app/modules/web/components/widget/components/inputs/new-datepicker/new-datepicker.component";
import { DatepickerComponent } from "src/app/modules/web/components/widget/components/inputs/datepicker/datepicker.component";
import { stringify } from "querystring";
//import * as sticky from "sticky-table-headers";
declare const stickyTableHeaders: any;
moment.locale('es');

@Component({
  selector: "app-web-table",
  templateUrl: "./web-table.component.html",
  styleUrls: ["./web-table.component.scss"]
})
export class WebTableComponent implements OnInit {
  @Input("products") product: any;
  @Output("selected") selected: EventEmitter<any> = new EventEmitter<any>();
  @Output("toPayment") payment: EventEmitter<any> = new EventEmitter<any>();
  @Output('selectCard') selectCard = new EventEmitter<any>();

  public super: any;
  public univ: any;
  public super_id: any;
  public elite: any;
  public elite_id: any;
  public budget: any;
  public budget_id: any;
  public mexico: any;
  public isMobile = false;
  public mexico_id: any;
  public april: any;
  public april_id: any;
  public seguros: any;
  public endDate=moment(new Date().setFullYear(new Date().getFullYear() + 1)).format('YYYY-MM-DD')
  public endDatePicker2:Date=new Date();//Date=new Date().setDate(new Date().getDate() + 50 );
  public segurosHidden: any;
  public segurosAll: any;
  public showTableMobile: Boolean = false;
  public mySeguros: any;
  public myTable: HTMLElement;
  output: any[];
  data: any;
  public dataBudget: any;
  public eliteBudget: any;
  public budgetId: any;
  public budgetDestacado: any;
  public contentBudget: any;
  public mobileDate = '';
  titleProduct: any;
  campos: any;
  ids: any;
  mySelect: any;
  discount: number;
  part_date;
  return_date;
  part_date_date: any;
  return_date_date: any;
  _return_date_date: any;
  fDestino: any;
  pasajeros: any;
  camposMexico: any;
  searchForm: FormGroup;
  @ViewChild('picker1') datePicker: DatepickerComponent;
  @ViewChild('picker2') datePicker2: DatepickerComponent;
  public inicio: Date = new Date(new Date().setDate(new Date().getDate() + 1));
  submitted: boolean;
  newSearchForm: FormGroup;
  passSum: any;
  productRecommended: String;
  public maxDays: any = false;

  constructor(private router: Router, private route: ActivatedRoute, private searchService: SearchService,
    private formBuilder: FormBuilder) {
    this.seguros = JSON.parse(localStorage.getItem('table')).table;
    this.segurosHidden = JSON.parse(localStorage.getItem('hiddenTable')).table;
    this.segurosAll = [];
    this.segurosAll = this.segurosAll.concat(this.seguros, this.segurosHidden);

    this.getData();

  }



  ngOnInit() {
    if (this.router.url.includes('/m/seguros/resultados/destino?dateFrom=')) {
      this.route.queryParams.subscribe(params => {
        let numPass = params.fPasajeros
        this.pasajeros = JSON.parse(numPass)

        this.passSum = Object.keys(this.pasajeros).reduce((sum,key)=>sum+parseFloat(this.pasajeros[key]||0),0);

        if (JSON.stringify(params) !== '{}') {

          var dateParts = params.dateFrom.split("/");
          var dateObject = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);

          var dateParts2 = params.dateTo.split("/");
          var dateObject2 = new Date(+dateParts2[2], dateParts2[1] - 1, +dateParts2[0]);

          this.part_date = moment(dateObject).format('DD MMM YYYY');
          this.return_date = moment(dateObject2).format('DD MMM YYYY');

          this.part_date_date = dateObject//moment(dateObject).format('DD-MM-YYYY');
          this.return_date_date = dateObject2//moment(dateObject2).format('DD-MM-YYYY');
          this._return_date_date = dateObject;
          this.fDestino = params.fDestino;
          this.mobileDate = `${moment(dateObject).format('DD MMM YYYY')} - ${moment(dateObject2).format('DD MMM YYYY')}`;

          this.setValForm();
        }

      });
    }

    this.newSearchForm = this.formBuilder.group({
      date1: [this.part_date, Validators.required],
      date2: [this.return_date, Validators.required],
      destino: ['', [Validators.required]],
      vAdult: [1, [Validators.required, Validators.min(0)]],
      vChild: [0, [Validators.required, Validators.min(0)]],
      travels: [this.pasajeros, [Validators.required, Validators.min(1)]],
      isInternational: [true, []]

    })

    this.newSearchForm.controls.destino.setValue(this.fDestino);
    this.newSearchForm.controls.date2.setValue(this.return_date);

    if (this.fDestino === 'México') {
      this.endDatePicker2.setDate(this.endDatePicker2.getDate() + 120);
    } else  {
      this.endDatePicker2.setDate(this.endDatePicker2.getDate() + 730);

    }

    this.editSearch();

    //INFORMACION PARA LLENAR EL HEADER Y RELACION ID.

    this.super = this.product.filter(p =>
      p.productType.toLowerCase().includes('super')
    )[0];
    this.elite = this.product.filter(p =>
      p.productType.toLowerCase().includes('elite')
    )[0];
    this.budget = this.product.filter(p =>
      p.productType.toLowerCase().includes('budget')
    )[0];
    this.mexico = this.product.filter(p =>
      p.productType.toLowerCase().includes('mexico')
    )[0];
    this.april = this.product.filter(p =>
      p.productType.toLowerCase().includes('april')
    )[0];
    this.univ = this.product.filter(p =>
      p.productType.toLowerCase().includes('univ')
    )[0];

    this.isMobile = window.innerWidth > 991 ? false : true;
    //table desk
    $(document).ready(function () {
    setTimeout(function() {
      //let idi = document.getElementById('table-insurance-desk').style
      $('.table-desk-product').clone(true).appendTo('#table-insurance-desk').addClass('clone');
      if (document.documentElement.clientWidth > 991) {
        $('.table-desk-product').stickyTableHeaders();
      }else{
        $('.products-desk').removeClass("display-table")
      }
      window.onresize = () => {
        if (document.documentElement.clientWidth > 991) {
          $('.table-desk-product').stickyTableHeaders();
          //$('.products-desk').addClass("display-table")
        } else {
          $('.table-desk-product').stickyTableHeaders('destroy');
          $('.products-desk').removeClass("display-table")
        }
      };

    }, 1000);
    });
    //end table desk

    //drag table desk




    var mx = 0;

    $(".drag").on({
      mousemove: function (e) {
        var mx2 = e.pageX - this.offsetLeft;
        if (mx) this.scrollLeft = this.sx + mx - mx2;
      },
      mousedown: function (e) {
        this.sx = this.scrollLeft;
        mx = e.pageX - this.offsetLeft;
      }
    });

    $(document).on("mouseup", function () {
      mx = 0;
    })
    //end drag table desk
    this.mySeguros = this.seguros


    this.product.map(res => {

        if(res.discount == true){
          this.discount = res.percentageDiscount * 100
        }
    });

/*
    this.searchForm.get('date').valueChanges.subscribe(val => {
      if (val.includes('01-07-2020') || val.includes('02-07-2020')) {
        this.searchForm.get('date').setValue([this.part_date_date]);
      }
      const date2 = this.searchForm.get('date2').value;
      if (val.length > 0 && date2 > 0) {
        return;
      } else {
        const mStart = moment('DD-MM-YYYY', val).toISOString();
        const mEnd = moment('DD-MM-YYYY', date2);
        }
    });*/
  }

  setValForm() {
    this.searchForm = this.formBuilder.group({
      date: [[this.part_date_date], [Validators.required]],
      date2: [[this.return_date_date], [Validators.required]],
      destino: [this.fDestino, [Validators.required]],
      vAdult: [this.pasajeros.vAdult, [Validators.required, Validators.min(0)]],
      vChild: [this.pasajeros.vChild, [Validators.required, Validators.min(0)]],
      travels: [this.pasajeros, [Validators.required, Validators.min(1)]],
      isInternational: [true, []]
    });
    
  }



  /// 1400 992

  onResize(event) {
    this.isMobile = window.innerWidth > 991 ? false : true;
  }

  activeScroll() {
    $('html').css('overflow', 'auto');
  }

  disableScroll() {
    $('html').css('overflow', 'hidden');
  }


  get f() { return this.searchForm.controls; }
  get fS() { return this.newSearchForm.controls; }



  scrollTop(insurance) {
    $('html, body').animate({
      scrollTop: $('body').offset().top - 120
    },
      'slow'
    );
    this.selectCard.emit({ insurance: insurance });
  }

  toogleTableMobile() {
    console.log("presiona boton mostrar")
    this.isMobile = !this.isMobile;
    this.showTableMobile = !this.showTableMobile;
    $('.products-desk').addClass("display-table")
    /*$(document).ready(function () {
      $('.table-mobile-product').clone(true).appendTo('#table-insurance-mobile').addClass('clone');
    });*/
  }



  selectProduct(id, n) {

    //Seleccionar producto
    const element = document.getElementsByClassName('product');
    for (let _i = 0; _i < element.length; ++_i) {
      element[_i].classList.remove('selected');
    }
    const d = document.getElementById('p-' + id);
    d.className += ' selected';

    //Seleccionar tabla
    const element2 = document.getElementsByClassName('columna');
    for (let a = 0; a < element2.length; ++a) {
      element2[a].classList.remove('bg-selected');
    }
    const d2 = document.getElementById('t-' + id);
    d2.className += ' bg-selected';

    //Seleccionar celdas de tabla
    const element3 = document.getElementsByClassName('fila');
    for (let b = 0; b < element3.length; ++b) {
      $(element3[b].childNodes[1]).removeClass('bg-selected');
      $(element3[b].childNodes[2]).removeClass('bg-selected');
      $(element3[b].childNodes[3]).removeClass('bg-selected');
      $(element3[b].childNodes[4]).removeClass('bg-selected');
      $(element3[b].childNodes[5]).removeClass('bg-selected');
      $(element3[b].childNodes[6]).removeClass('bg-selected');
      $(element3[b].childNodes[7]).removeClass('bg-selected');
      $(element3[b].childNodes[8]).removeClass('bg-selected');
      $(element3[b].childNodes[9]).removeClass('bg-selected');
      $(element3[b].childNodes[10]).removeClass('bg-selected');
      $(element3[b].childNodes[n]).addClass('bg-selected');
    }


    if (document.getElementById('btn-' + id).innerHTML === 'Comprar') {
      this.payment.emit(
        this.product.filter(
          p => p.vouchers.filter(p1 => p1.productId === id).length > 0
        )[0]
      );
      return false;
    }

    //Seleccionar botón
    const element4 = document.getElementsByClassName('btn-select');
    for (let i = 0; i < element4.length; ++i) {
      element4[i].innerHTML = 'Elegir';
    }

    document.getElementById('btn-' + id).innerHTML = 'Comprar';

    //Enviar producto seleccionado
    this.selected.emit(
      this.product.filter(
        p => p.vouchers.filter(p1 => p1.productId === id).length > 0
      )[0]
    );

    //Mover al producto seleccionado
    $('html, body').animate(
      { scrollTop: $('#p-' + id).offset().top - 120 },
      'slow'
    );
  }


  //FUNCION PARA LLAMAR AL SERVICIO QUE APUNTA AL ENDPOINT DE WORDPRESS
  getData() {

    // LOS IDS ESTAN RELACIONADOS CON LA DATA DE VOUCHERS ID
    let seguroTH = document.getElementsByTagName('th')



    //SE LLAMA EL SERVICIO
    this.searchService.getDynamicTable()
      .subscribe((result: any) => {

        this.data = result



        // se jala toda la data
        this.dataBudget = this.data[0].acf
        if (this.dataBudget) {

          if(this.dataBudget.wp_tablas_dinamicas_idproddesta!=undefined && this.dataBudget.wp_tablas_dinamicas_idproddesta!=null){
            if(this.dataBudget.wp_tablas_dinamicas_idproddesta.value!=undefined && this.dataBudget.wp_tablas_dinamicas_idproddesta.value!=null){
              this.productRecommended=this.dataBudget.wp_tablas_dinamicas_idproddesta.value.toUpperCase();
            }
          }
          this.titleProduct = []
          this.campos = []
          this.ids = []
          this.camposMexico = []

          this.contentBudget = []
          this.contentBudget = this.dataBudget.key_rep_field_wp_tablas_dinamicas_filas
          let tempVar;
          let dataList=[]
          this.contentBudget.map(response => {
            let normal=false
            let mexico=false
            let univ=false
          let row={
            'title':response.wp_tablas_dinamicas_filatitle,
            'tooltip':response.wp_tablas_dinamicas_tootipfila,
            'list':[]}
            // key_rep_field_wp_tablas_dinamicas_cmapos
            response.key_rep_field_wp_tablas_dinamicas_cmapos.forEach(campos => {
              tempVar = campos
              var info={'id':tempVar.wp_tablas_dinamicas_idproductotabla.value,
            'img':tempVar.wp_tablas_dinamicas_columnaimagen,
            'text':tempVar.wp_tablas_dinamicas_descripcioncolumna}
            row.list.push(info)
              // if(this.mexico&&this.april){
                
              // }else{

              // }
              
              if(tempVar.wp_tablas_dinamicas_idproductotabla.value != "4797" && tempVar.wp_tablas_dinamicas_idproductotabla.value != "4793"){
                if(tempVar.wp_tablas_dinamicas_idproductotabla.value=='6311'){
                  univ = true
                }else{
                  normal=true
                }
              }else{
                mexico=true
              }
            })
            if(mexico){
              this.camposMexico.push(row)
            }
            if(normal){
              this.titleProduct.push(row)
            }
            if(!normal&&univ&&this.univ!=undefined){
              this.titleProduct.push(row)
            }
            // if (tempVar.wp_tablas_dinamicas_idproductotabla.value != "México Lindo" && tempVar.wp_tablas_dinamicas_idproductotabla != "TW México") {
            //   this.titleProduct.push(response)

            // } else {
            //   this.camposMexico.push(response)

            // }
            dataList.push(row)
          });
        console.log("dataList",dataList);

        }


console.log("this.camposMexico",this.camposMexico)
console.log("this.titleProduct",this.titleProduct)

      });


  }

  getTextByTableList(data,id){
   const info= data.list.filter(p =>p.id==id);
    if(info!=undefined&&info!=null&&info.length>0){
      if(info[0].text!=undefined&&info[0].text!=null&&info[0].text!=""&&info[0].text!="undefined"){
        return info[0].text;
         }else{
         return ""
       }
      
    }

  }
  getImgByTableList(data,id){
    const info= data.list.filter(p =>p.id==id);
     if(info!=undefined&&info!=null&&info.length>0){
       if(info[0].img!=undefined&&info[0].img!=null&&info[0].img!=""&&info[0].img!="undefined"){
        return info[0].img;
       }else{
         return false
       }
     }else{
       return false;
     }
 
   }
  strip(img,html){
    if(!html||html==""){
      if(img==false){
        return "-"
      }else{
        return ""
      }
    }
    var doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.body.textContent&&doc.body.textContent!=undefined? doc.body.textContent: "-";
 }

  paySeguro(ev, n) {
    const target = ev.target.value

    switch(target){
      case 'univ-btn':
      sessionStorage.setItem('product', JSON.stringify(this.univ))
      this.mySelect = this.univ
        break;

      case 'elite-btn':
        sessionStorage.setItem('product', JSON.stringify(this.elite))
        this.mySelect = this.elite
        break;

      case 'budget-btn':
        sessionStorage.setItem('product', JSON.stringify(this.budget))
        this.mySelect = this.budget
        break;

      case 'super-btn':
        sessionStorage.setItem('product', JSON.stringify(this.super))
        this.mySelect = this.super
        break;

      case 'mex-btn':
        sessionStorage.setItem('product', JSON.stringify(this.mexico))
        this.mySelect = this.mexico
        break;

      case 'april-btn':
        sessionStorage.setItem('product', JSON.stringify(this.april))
        this.mySelect = this.april
        break;

    }
    this.buildGeneralDataLayer()
    this.router.navigate(['m/seguros/step-one'])
  }

  buildGeneralDataLayer() {


    const data = {
      category: this.mySelect.productType,
      name: this.mySelect.vouchers[0].productName,
      content_type: 'insurance',
      id: this.mySelect.vouchers[0].productId,
      departing_departure_date:this.part_date.split("-").reverse().join("-"),
      returning_departure_date: this.return_date.split("-").reverse().join("-"),
      currency: 'MXN',
      page_category: 'search',
      url_search: this.router.url,
      visitor_type: 'medium-value',
      date_search: moment(new Date()).format('YYYY-MM-DD'),
      time_search: moment(new Date()).format('HH:mm')
    };

    window.dataLayer.push({
      'event': 'insurance_selected_product',
      'valData': data,
      'insurance_selected_product': data
    });
  }

  editSearch(){
    this.newSearchForm.controls.date1.valueChanges.subscribe(value => {
     let newVal = value
     console.log(newVal)
  })

    this.newSearchForm.controls.date2.valueChanges.subscribe(value => {
      let newVal = value
    })

   let radioInp = document.getElementsByName('radios')
    radioInp.forEach(res => {
      res.addEventListener('click', (data) => {
        let radioSelected = (data.target as HTMLInputElement).value;
        this.newSearchForm.controls.destino.setValue(radioSelected);
        this.searchForm.controls.destino.setValue(radioSelected);

        var fecha=this.searchForm.controls.date.value[0].split('-') 
        //this.endDate=new Date(+fecha[2], fecha[1] - 1, +fecha[0])
        this.endDatePicker2=new Date(+fecha[2], fecha[1] - 1, +fecha[0])
        if (this.searchForm.controls.destino.value === 'México') {
          this.endDatePicker2.setDate(this.endDatePicker2.getDate() + 120);
          //this.endDate
        } else  {
          this.endDatePicker2.setDate(this.endDatePicker2.getDate() + 730);
        }
      })
    })


  }

  calViajeros(v, n) {
    if (v === 'adulto') {
      if ( n === '+') {
        this.searchForm.controls['vAdult'].setValue(this.f.vAdult.value + 1);
      } else if (this.f.vAdult.value !== 0) {
        this.searchForm.controls['vAdult'].setValue(this.f.vAdult.value - 1);
      }
    }

    if (v === 'child') {
      if ( n === '+') {
        this.searchForm.controls['vChild'].setValue(this.f.vChild.value + 1);
      } else if (this.f.vChild.value !== 0) {
        this.searchForm.controls['vChild'].setValue(this.f.vChild.value - 1);
      }
    }

    this.searchForm.controls['travels'].setValue(this.f.vChild.value + this.f.vAdult.value);
  }

  onSubmit() {
    this.submitted = true;
    this.activeScroll();
    if (this.searchForm.invalid) {
      return;
    }
    const url = this.buildUrl(this.f);

    console.log('url --------->', url);
    this.router.navigate(["/m/seguros/resultados/destino"], { queryParams: url });
  }

  buildUrl(f) {
    let date1Format = f.date.value[0].split('-').join('/')
    let date2Format = f.date2.value[0].split('-').join('/')
    const urlBase = {
      dateFrom: date1Format,
      dateTo: date2Format,
      maxAgeIsic: 30,
      maxAgeNormal: 50,
      passengerIsic: 0,
      passengerNormal: (f.vAdult.value+f.vChild.value),
      fDestino: f.destino.value,
      isInternational: f.destino.value === 'México' ? false : true,
      fPasajeros: JSON.stringify({ vAdult: f.vAdult.value,  vChild: f.vChild.value })
    };
    return urlBase;
  }

  buildNewUrl(fS){
    const urlBase = {
      dateFrom: fS.date1.value,
      dateTo: fS.date2.value,
      maxAgeIsic: 30,
      maxAgeNormal: 50,
      passengerIsic: 0,
      passengerNormal: 1,
      fDestino: fS.destino.value,
      isInternational: fS.destino.value === 'México' ? false : true,


    }
    return urlBase
  }

  onSubmitNew(){
    console.log('formmm', this.newSearchForm.value)
    const url = this.buildNewUrl(this.fS);
    console.log('url---____>', url)
    this.router.navigate(["/m/seguros/resultados/destino"], { queryParams: url })
  }

  Change2Date()
  {
    var temporal:Date=new Date()
    this.newSearchForm.controls.date2.setValue(this.searchForm.controls.date.value);
    const fecha= this.searchForm.controls.date.value[0].split('-') 

    this._return_date_date=new Date(+fecha[2], fecha[1] - 1, +fecha[0])
    this.part_date_date= this._return_date_date
    temporal=this._return_date_date
    temporal.setDate(temporal.getDate() + 3)
    var fechaMoment=moment(temporal).format('DD-MM-YYYY').toString().split('-');
 
    var fruits: string[] = []
    var stri=fechaMoment[0] +'-' + fechaMoment[1]+'-' + fechaMoment[2]
    fruits.push(stri)
    this.searchForm.controls.date2.setValue(fruits)


    var fechaEndpicker2=this.searchForm.controls.date2.value[0].split('-') 
    this.endDatePicker2=new Date(+fechaEndpicker2[2], fechaEndpicker2[1] - 1, +fechaEndpicker2[0])
        if (this.searchForm.controls.destino.value === 'México') {
          this.endDatePicker2.setDate(this.endDatePicker2.getDate() + 120);
          //this.endDate
        } else  {
          this.endDatePicker2.setDate(this.endDatePicker2.getDate() + 730);
        }
  }

  cierraVista(){
    this.showTableMobile = !this.showTableMobile;
    $('.products-desk').removeClass("display-table")
    console.log("se cierra vista")
  }

}
